import { FilterType } from '@Common/Enums';
import { DimensionFilterValue, DimensionFilterValues } from '@InstanceFactory';

import formatHelper from '../Helpers/FormatHelper';

export function filterValue(id: any, value?: any): DimensionFilterValue {
    return DimensionFilterValue.create({
        id: formatHelper.formatValueByInvariantCulture(id),
        value: formatHelper.formatValueByInvariantCulture(value == null ? id : value)
    });
}

export function dimensionFilterValue(id: string, values?: DimensionFilterValue[], filterType?: FilterType): DimensionFilterValues {
    return DimensionFilterValues.create({
        id: id,
        values: values,
        filterType: filterType ? filterType : FilterType.whereIn
    });
}
